import React from 'react';

import { Modal } from '@/ui/Modal';

type JourneyEditViewTeamsResetModalProps = {
  open: boolean;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
  loading?: boolean;
};

/**
 * Confirms a reset before it happens. Reset is destructive in a way the button does not admit
 * to: it discards the hand-edits an admin may have spent a while on, and nothing brings them
 * back, so the copy names that rather than only asking whether a reset should happen.
 */
export const JourneyEditViewTeamsResetModal = ({
  open,
  onClose,
  onConfirm,
  loading,
}: JourneyEditViewTeamsResetModalProps): JSX.Element => (
  <Modal open={open} onClose={onClose} size="mobile">
    <Modal.Title>Reset learning teams</Modal.Title>
    <Modal.Contents>
      Reset removes all learning teams and any manual changes you made to them. You cannot undo this.
    </Modal.Contents>
    <Modal.Actions>
      <Modal.Action action={onClose} disabled={loading}>
        Cancel
      </Modal.Action>
      <Modal.Action variant="primaryDanger" action={onConfirm} loading={loading}>
        Reset
      </Modal.Action>
    </Modal.Actions>
  </Modal>
);
